module.exports = __webpack_public_path__ + "assets/projects/maria-jose-moreno/transition.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/maria-jose-moreno/transition.mp4
// module id = 52
// module chunks = 0